import { LeftArrow } from '@/frontend/SVGs/LeftArrow';
import { I18n } from '@/i18n/I18n';
import { ReactElement, ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RightArrow } from '@/frontend/SVGs/RightArrow';
import { scrollToTop } from '@/frontend/utils/scrollTo';
import { useGetFirstPendingStep } from '@/frontend/hooks/useGetFirstPendingStep';

export function GenericSideNav(props: { children: ReactNode, link: ReactElement, title: string }) {
  const { children, link, title } = props;
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  // const procedure = useProcedureStore((state) => state.procedure);

  const firstIncompleteStep = useGetFirstPendingStep();
  // const continueFromStepLink = location.pathname.includes('wizard') ? `/procedures/wizard/${procedure?.id}/steps/${firstIncompleteStep?.id}` : `#${firstIncompleteStep?.id}`;
  const continueFromStepLink = `#${firstIncompleteStep?.id}`;

  return (
    <>
      { isCollapsed &&
        <nav className="sticky-top" style={{ height: 'fit-content', top: '10px' }}>
          <button className='float-start pe-auto btn' onClick={() => setIsCollapsed(!isCollapsed)} title={I18n.get('toggleSideNavigation')}>
            <RightArrow />
          </button>
          {/* <ButtonParent
            className="float-start pe-auto"
            title={I18n.get('toggleSideNavigation')}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <RightArrow />
          </ButtonParent> */}
        </nav>
      }
      { !isCollapsed &&
        <aside key="side-nav" style={{ resize: 'horizontal', maxHeight: '100vh', height: '100vh' }} className=' h-100 mh-100 bd-sidebar sticky-top pt-1 border-end'>
          <nav className="navbar d-flex flex-column  align-items-start scrollable-hidden h-100" style={{ scrollbarWidth: 'thin', paddingBottom:  '0', paddingTop: '0' ,'width': '275px', maxWidth: '460px', 'flexWrap': 'nowrap', 'maxHeight': '100%', resize: 'horizontal'}} id='navbarScroller'>
            <nav aria-label="breadcrumb" className='sticky-top bg-body w-100'>
              <div className='d-flex align-items-start ps-2'>
                <ul className="breadcrumb m-0 pb-2 align-items-start">
                  <li className="breadcrumb-item ">
                    {link}
                  </li>
                  <li className="breadcrumb-item active max-w-80" aria-current="page">{title}</li>
                </ul>
                <button className='btn' style={{ marginLeft: 'auto' }} onClick={() => setIsCollapsed(!isCollapsed)} title={I18n.get('toggleSideNavigation')}>
                  <LeftArrow />
                </button>
                {/* <ButtonParent
                  className="pe-auto btn btn-primary"
                  title={I18n.get('toggleSideNavigation')}
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  style={{ marginLeft: 'auto' }}
                >
                  <LeftArrow />
                </ButtonParent> */}
              </div>
              <div className="ps-2">
                <div className="text-center w-95 border border-2 border-subtle rounded pb-2">
                  {!location.pathname.includes('wizard') && <button type='button' className='btn btn-link fs-6' onClick={scrollToTop}>{I18n.get('backToTop')}</button>}
                  {firstIncompleteStep?.container.title && (
                    <div className='d-flex flex-column align-items-center'>
                      {!location.pathname.includes('wizard') && <hr className='m-1 w-50 border-2 opacity-75' />}
                      <Link className='d-block' to={continueFromStepLink}>{I18n.get('resumeFromStep', { step: firstIncompleteStep.container.title })}</Link>
                    </div>
                  )}
                </div>
              </div>
              <hr className='w-100' />
            </nav>
            {children}
          </nav>
        </aside>
      }
    </>
  );
}
